import { toast } from 'sonner'

/**
 * Copy text to clipboard and show a success toast
 * @param text - The text to copy to clipboard
 * @param successMessage - Optional custom success message (defaults to "Copied to clipboard")
 * @returns Promise that resolves when copy is complete
 */
export async function copyToClipboard(
	text: string,
	successMessage = 'Copied to clipboard'
): Promise<void> {
	try {
		await navigator.clipboard.writeText(text)
		toast.success(successMessage)
	} catch (error) {
		console.error('Failed to copy to clipboard:', error)
		toast.error('Failed to copy to clipboard')
	}
}

/**
 * Copy address to clipboard with formatted success message
 * @param address - The address to copy
 * @param chain - Optional chain name to include in the message
 */
export async function copyAddress(address: string, chain?: 'Polygon' | 'Solana'): Promise<void> {
	const message = chain ? `${chain} address copied` : 'Address copied'
	await copyToClipboard(address, message)
}
